/* WCF-040 card swatch runtime */
(() => {
  if (window.__wcfCardColorSwatchesInstalled) return;
  window.__wcfCardColorSwatchesInstalled = true;

  function updateCardTargets(card, swatch) {
    const href = swatch.dataset.wcfVariantUrl;
    if (!href) return;

    card.querySelectorAll('[data-wcf-card-product-link]').forEach((link) => {
      link.href = href;
    });
    card.querySelectorAll('[data-wcf-quick-add-url]').forEach((opener) => {
      opener.dataset.productUrl = href;
    });
    card.querySelectorAll('[data-wcf-bulk-url]').forEach((modal) => {
      modal.dataset.url = href;
    });
  }

  function handleSwatch(event) {
    const target = event.target;
    const swatch = target && typeof target.closest === 'function'
      ? target.closest('[data-wcf-color-swatch]')
      : null;
    if (!swatch) return;

    const card = swatch.closest('.card-wrapper');
    const image = card?.querySelector('img[data-wcf-primary-image]');
    if (!card || !image || !swatch.dataset.wcfImageUrl || !swatch.dataset.wcfVariantUrl) return;

    event.preventDefault();
    event.stopPropagation();

    updateCardTargets(card, swatch);
    image.src = swatch.dataset.wcfImageUrl;
    image.removeAttribute('srcset');
    image.alt = swatch.dataset.wcfImageAlt || image.alt;

    const secondaryImage = card.querySelector('img[data-wcf-secondary-image]');
    const isInitialSwatch = swatch.hasAttribute('data-wcf-initial-swatch');
    if (secondaryImage) {
      secondaryImage.hidden = !isInitialSwatch;
      secondaryImage.style.display = isInitialSwatch ? '' : 'none';
    }
    image.style.opacity = isInitialSwatch ? '' : '1';

    card.querySelectorAll('[data-wcf-color-swatch]').forEach((button) => {
      const active = button === swatch;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  }

  document.addEventListener('click', handleSwatch, true);
})();
